/**
 * Styled Components - Created by Render2D component.
 */
import styled from 'styled-components'

export const Arrow = styled.img`
  height: 36px !important;
  width: 36px !important;
  padding: 8px !important;
  text-align: center !important;
  z-index: 1 !important;
  transition: opacity 0.3s ease;
  &:hover {
    opacity: 1;
  }
`

export const CarouselContainer = styled.div`
  width: 100%;
  height: 100%;
  overflow: hidden;
  padding-bottom: 20px;
  .slick-slider,
  .slick-list,
  .slick-track,
  .slick-slide,
  .slick-slide > div {
    height: 100%;
  }
  .render2d-image {
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
    display: block;
    margin: 0 auto;
    cursor: pointer;
    -webkit-user-drag: none;
    -khtml-user-drag: none;
    -moz-user-drag: none;
    -o-user-drag: none;
  }
  .slick-prev {
    left: 0px !important;
    background: white;
    border-radius: 25px;
  }
  .slick-next {
    right: 0px !important;
    background: white;
    border-radius: 25px;
  }
`



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/components/DesignImageCarousel/styledComponents.tsx